export default __webpack_public_path__ + "static/media/CHENNAI-6.075a9666.webp";